import React, { useRef, useState, useEffect, useCallback } from 'react';

import {
  HorizontalCollapsibleContainer,
  HorizontalCollapsibleChildren,
} from './styles';

interface ICollapsibleBodyProps {
  children: React.ReactNode;
  isOpen: boolean;
  customBodyStyle?: React.CSSProperties;
  nested?: boolean;
}

const HorizontalCollapsibleBody: React.FC<ICollapsibleBodyProps> = ({
  children,
  isOpen,
  customBodyStyle,
  nested,
}) => {
  const [maxWidth, setMaxWidth] = useState<number>(0);
  const content = useRef<HTMLDivElement>(null);

  const handleResize = () =>
    setMaxWidth(isOpen && content.current ? content.current.scrollWidth : 0);
  const handleResizeCallback = useCallback(handleResize, [isOpen]);

  useEffect(() => {
    handleResize();
  }, [children]);

  useEffect(() => {
    window.addEventListener('resize', handleResizeCallback);
    return () => {
      window.removeEventListener('resize', handleResizeCallback);
    };
  }, [handleResizeCallback]);

  useEffect(() => {
    setMaxWidth(isOpen ? content.current!.scrollWidth : 0);
  }, [isOpen, children]);

  useEffect(() => {
    setTimeout(() => {
      if (content.current && isOpen) {
        content.current.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  }, [isOpen]);

  return (
    <HorizontalCollapsibleContainer
      ref={content}
      maxWidth={nested && maxWidth ? 'unset' : maxWidth}
      open={isOpen}
    >
      <HorizontalCollapsibleChildren style={customBodyStyle && customBodyStyle}>
        {children}
      </HorizontalCollapsibleChildren>
    </HorizontalCollapsibleContainer>
  );
};

export default HorizontalCollapsibleBody;
